import { render } from "./InsuranceOperationsNew.vue?vue&type=template&id=7ac90747&scoped=true"
import script from "./InsuranceOperationsNew.vue?vue&type=script&lang=js"
export * from "./InsuranceOperationsNew.vue?vue&type=script&lang=js"

import "./InsuranceOperationsNew.vue?vue&type=style&index=0&id=7ac90747&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac90747"]])

export default __exports__